import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { apiRequest } from '../lib/api';

export type MeasurementRecord = {
  id: string;
  date: string;
  weight_kg: number | null;
  height_cm: number | null;
  waist_cm: number | null;
  chest_cm: number | null;
  hips_cm: number | null;
  bmi: number | null;
  body_fat_percentage: number | null;
  note: string | null;
  photo_urls?: string[];
  photo_names?: string[];
  created_at: string | null;
};

async function fetchMeasurements(
  clientId: string,
  accessToken: string | null | undefined,
) {
  return apiRequest<MeasurementRecord[]>(
    `/api/clients/${clientId}/measurements`,
    { method: 'GET' },
    accessToken,
  );
}

export function useClientMeasurements(clientId: string) {
  const { session } = useAuth();

  return useQuery<MeasurementRecord[]>({
    queryKey: ['measurements', clientId],
    enabled: Boolean(clientId && session),
    queryFn: () => fetchMeasurements(clientId, session?.access_token),
  });
}

export function useInvalidateMeasurements(clientId: string) {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: ['measurements', clientId],
    });
}
